import { useState, useMemo } from 'react'

interface TabConfig {
  key: string
  label: string
  component: React.ComponentType
}

export const useTabManager = (tabs: TabConfig[]) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.key || '')
  const [loadedTabs, setLoadedTabs] = useState<Set<string>>(new Set([tabs[0]?.key || '']))

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey)
    setLoadedTabs(prev => new Set([...Array.from(prev), tabKey]))
  }

  const tabComponents = useMemo(() => {
    return tabs.map(tab => {
      const isLoaded = loadedTabs.has(tab.key)
      const isActive = activeTab === tab.key

      return {
        ...tab,
        isLoaded,
        isActive,
        shouldRender: isLoaded && isActive,
      }
    })
  }, [tabs, loadedTabs, activeTab])

  return {
    activeTab,
    handleTabChange,
    tabComponents,
  }
}
